import { jwtDecode } from "jwt-decode";

export const ACCESS_TOKEN_STORAGE_KEY = "@azure:token";

interface AccessTokenPayload {
  substitution?: {
    period_start?: string;
    period_end?: string;
    inheritedEntityId?: number;
  };
}

/**
 * `true` when the current JWT (`@azure:token`) carries the `substitution` claim (the "token" signal
 * of the display×token gate). Fail-safe: missing/invalid token → `false`.
 */
export function hasSubstitutionClaim(): boolean {
  const token = localStorage.getItem(ACCESS_TOKEN_STORAGE_KEY);

  if (!token) {
    return false;
  }

  try {
    const payload = jwtDecode<AccessTokenPayload>(token);
    return payload?.substitution != null;
  } catch {
    return false;
  }
}
